module.exports = __webpack_public_path__ + "static/media/carousel-placeholder-03.574f125f.jpg";